import { useContext } from "react";
import { answerResultContext } from "../contexts/answerResult";

export const useAnswerResult = () => {
  const context = useContext(answerResultContext);
  if (context === undefined) {
    throw new Error("useSwiperAnswers must be used within a SwiperAnswersProvider");
  }
  return context;
};
